import { ColorSchemeToggle } from "metabase/common/components/ColorSchemeToggle";

export const NightModeToggleButton = () => {
  return <ColorSchemeToggle variant="viewHeader" />;
};
